export const _valueCardUISchema = {
    vat: {
    'ui:enumDisabled': [10, 14, 24],
  },
}
export const _valueCardClass = {
  // 'Lahjakortti' already names three other things - the gift-certificate payment mark, the
  // giftcode discount code, and a dead stub in the functions repo. This one is an arvokortti.
  name: { type: 'string', title: 'Arvokortin nimi' },
  price: { type: 'number', title: 'Hinta (€)' },
  extra: { type: 'number', title: 'Asiakkaalle annettava lisäarvo (€)', default: 0},
  description: { type: 'string', title: 'Kuvaus' },
  validity: {
    type: 'string',
    title: 'Voimassaoloaika',
    oneOf: [
      { const: 'rolling', title: 'Rullaava ajanjakso' },
      { const: 'next', title: 'Seuraavaan ajanjaksoon' },
      { const: 'fixed', title: 'Kiinteä ajanjakso' },
      { const: 'permanent', title: 'Pysyvä' },
    ],
  },
  type: {
    type: 'string',
    title: 'Arvokortin tyyppi',
    description: 'Voiko arvokortilla ostaa vain yhden alv kannan tuotteita vai kaikkia tuotteita.',
    oneOf: [
      { const: 'single', title: 'Yksiarvo' },
      { const: 'multi', title: 'Moniarvo' },
    ],
    default: 'single',
  },
  // A hard accounting boundary, not a label. Within tali the venues Tali and Taivallahti have
  // different business IDs, so a card issued at one may never pay at the other, and every
  // total, report and expiry roll-up is per venue. See docs/features/valuecards-functions-spec.md §3.
  //
  // Stores the venue NAME, not the document id: the backend's getVenueName does
  // `product.venue.toLowerCase()`, and the saldo wallet path is keyed by that same lowercased
  // string. The options are filled from customers/{cid}/venues at render time, the way the
  // webshop image list is; 'default' is the single-venue case and the value assumed when unset.
  venue: {
    type: 'string',
    title: 'Venue',
    oneOf: [{ const: 'default', title: 'Oletus' }],
    default: 'default',
  },
  availableinshop: {
    type: 'string',
    title: 'Näytetäänkö verkkokaupassa (Ominaisuus ei vielä käytössä)',
    oneOf: [
      { const: 'true', title: 'Kyllä' },
      { const: 'false', title: 'Ei' },
    ],
    default: 'false',
  },
  canpurchasewithsportmoney: {
    type: 'boolean',
    title: 'Voiko ostaa liikuntarahalla',
    default: false,
  },
    
}
export const _valueCardClassDeps = {
  // Mirrors benefitcard.js branch for branch, with one deliberate omission: benefit cards put
  // `accounting` in this branch, but a value card already carries it under type === 'single'.
  // Defining the same property in two dependency branches makes rjsf resolve whichever it
  // reaches first, so the shop branch leaves it alone.
  //
  // `image.items.images` ships empty and is filled at render time by the container, exactly as
  // BenefitCardsContainer does - imageWidget renders whatever is in that array, so without the
  // injection the picker opens blank.
  availableinshop: {
    oneOf: [
      {
        properties: {
          availableinshop: {
            enum: ['true'],
          },
          image: { type: 'string', title: 'Verkkokaupan tuotekuva', items: { type: 'object', images: [] }, minaspectratio: 1 },
          confirmationSubject: { type: 'string', title: 'Vahvistusviestin otsikko' },
          confirmationMessage: { type: 'string', title: 'Vahvistusviestin sisältö' },
        },
      },
      {
        properties: {
          availableinshop: {
            enum: ['false'],
          },
        },
      },
    ],
  },
  type: {
    oneOf: [
      {
        properties: {
          type: {
            enum: ['single']
          },
          vat: {
            type: 'number', title: 'ALV',
            oneOf: [
              { const: 0, title: '0%' },
              { const: 10, title: '10%' },
              { const: 13.5, title: '13,5%' },
              { const: 14, title: '14%' },
              { const: 24, title: '24%' },
              { const: 25.5, title: '25,5%' },
            ]
          },
          accounting: { type: 'string', title: 'Kirjanpidontili' },
          productCode: { type: 'string', title: 'Tuotekoodi' },
        },
      },
      {
        properties: {
          type: {
            enum: ['multi']
          },
          typedecission: {
            type: 'boolean',
            title: 'Päätetäänkö arvokortin tyyppi myynnin yhteydessä',
          },
        },
      },
    ]
  },
  validity: {
    oneOf: [
      {
        properties: {
          validity: {
            enum: ['rolling'],
          },
          unit: {
            type: 'string',
            title: 'Rullaava ajanjakso',
            oneOf: [
              { const: 'day', title: 'Päivä' },
              { const: 'week', title: 'Viikko' },
              { const: 'month', title: 'Kuukausi' },
              { const: 'year', title: 'Vuosi' },
            ],
          },
          amount: {
            type: 'number',
            title: 'Montako ajanjaksoa ostohetkestä',
          },
        },
      },
      {
        properties: {
          validity: {
            enum: ['next'],
          },
          endof: {
            type: 'string',
            title: 'Päättyy',
            oneOf: [
              { const: 'month', title: 'Kuukauden lopussa' },
              { const: 'year', title: 'Vuoden lopussa' },
            ],
          },
          daysahead: {
            type: 'number',
            title: 'Montako päivää ennen aletaan myydä seuraavaa ajanjaksoa. 0 = tästä hetkestä kuluvan ajanjakson loppuun asti.',
          },
        },
      },
      {
        properties: {
          validity: {
            enum: ['fixed'],
          },
          firstvalid: {
            type: 'string',
            title: 'Ensimmäinen voimassaolopäivä',
            format: 'date',
          },
          lastvalid: {
            type: 'string',
            title: 'Viimeinen voimassaolopäivä',
            format: 'date',
          },
        },
      },
      {
        properties: {
          validity: {
            enum: ['permanent'],
          },
          firstvalid: {
            type: 'string',
            title: 'Ensimmäinen voimassaolopäivä',
            format: 'date',
          },
        },
      },
    ],
  },
}
